import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {
    textTransform: 'unset',
    boxSizing: 'border-box',
    minWidth: 64,
    color: theme.palette.text.primary,
    transition: theme.transitions.create(
      ['background-color', 'box-shadow', 'border'],
      {
        duration: theme.transitions.duration.short,
      }
    ),
  },
  ol: {},
  li: {
    '&:nth-last-child(1)': {
      color: theme.palette.primary.main,
    },
    '&:nth-last-child(1) :hover': {
      textDecoration: 'none',
    },
    color: theme.palette.grey[900],
  },
  separator: {
    marginLeft: '20px',
    marginRight: '20px',
    '& svg': {
      height: '20px',
      width: '20px',
    }
  },
})
export default styleOverride
